import ReactGA from 'react-ga4';

// Track a page view
const pageView = (path, title) => {

  ReactGA.send({ hitType: "pageview", page: path, title: title });
}

// Track an event trigger
const triggerFunction = (triggerCategory, triggerLable) => {
  ReactGA.event({
    category: triggerCategory,
    action: 'Click',
    label: triggerLable
  });
}

// Creating enum object
const GoogleAnalyticsEnum = {
  // Pages ENUM
  HOME: "HOME",
  ABOUT_US: "ABOUT_US",
  CONTACT_US: "CONTACT_US",
  FAQs: "FAQs",
  CATEGORIES: "CATEGORIES",
  TESTIMONIAL: "TESTIMONIAL",
  PRIVACY_POLICY: "PRIVACY_POLICY",
  BLOGS: "BLOGS",
  SF_COURSE_DETAILS: "SF_COURSE_DETAILS",
  REACT_JS_COURSE_DETAILS: "REACT_JS_COURSE_DETAILS",
  JAVASCRIPT_COURSE_DETAILS: "JAVASCRIPT_COURSE_DETAILS",
  INSTRUCTOR_DETAILS: "INSTRUCTOR_DETAILS",
  USER_DETAILS: "USER_DETAILS",
  SALESFORCE_TUTORIALS: "SALESFORCE_TUTORIALS",
  INTERVIEW_QUESTIONS_SERIES: "INTERVIEW_QUESTIONS_SERIES",
  INTERVIEW_QUESTIONS_AND_ANSWER_DETAILS: "INTERVIEW_QUESTIONS_AND_ANSWER_DETAILS",
  SALESFORCE_KNOWLEDGE_CARD_ALL: "SALESFORCE_KNOWLEDGE_CARD_ALL",

  //Header Section Enum
  HEADER_HOME: "HEADER_HOME",
  HEADER_HOME_FAQS: "HEADER_HOME_FAQS",
  HEADER_COURSES: "HEADER_COURSES",
  HEADER_HOME_COURSES: "HEADER_HOME_COURSES",
  HEADER_FEATURES: "HEADER_FEATURES",
  HEADER_HOME_FEATURES: "HEADER_HOME_FEATURES",
  HEADER_ALL_FAQS: "HEADER_ALL_FAQS",
  HEADER_CONTACT_US: "HEADER_CONTACT_US",
  HEADER_ABOUT_US: "HEADER_ABOUT_US",
  // HEADER_OUR_GALLERY: "HEADER_OUR_GALLERY",
  HEADER_TUTORIALS: "HEADER_TUTORIALS",
  HEADER_INTERVIEW_QUESTIONS_AND_ANSWER: "HEADER_INTERVIEW_QUESTIONS_AND_ANSWER",
  HEADER_SALESFORCE_QUICK_INSIGHTS: "HEADER_SALESFORCE_QUICK_INSIGHTS",


  //Button ENUM
  BUTTON: "BUTTON",
  HOME_EXPLORE_LONGSWITCH_ACADEMY: "HOME_EXPLORE_LONGSWITCH_ACADEMY",
  HOME_COURSE_SALESFORCE: "HOME_COURSE_SALESFORCE",
  HOME_COURSE_REACTJS: "HOME_COURSE_REACTJS",
  HOME_COURSE_JAVASCRIPT: "HOME_COURSE_JAVASCRIPT",
  HEADER_BUTTON_SUBSCRIBE_NOW: "HEADER_BUTTON_SUBSCRIBE_NOW",
  FOOTER_HOME_SUBSCRIBE_NOW: "FOOTER_HOME_SUBSCRIBE_NOW",
  FOOTER_HOME_JOIN_NOW: "FOOTER_HOME_JOIN_NOW",
  HEADER_LOGO: "HEADER_LOGO",
  HOME_FAQ_READ_MORE_FAQ: "HOME_FAQ_READ_MORE_FAQ",
  HOME_FAQ_ACCORDIAN_BUTTON: "HOME_FAQ_ACCORDIAN_BUTTON",
  LOGIN_SUBMIT_BUTTON: "LOGIN_SUBMIT_BUTTON",
  REGISTER_SUBMIT_BUTTON: "REGISTER_SUBMIT_BUTTON",
  LOGOUT_BUTTON: "LOGOUT_BUTTON",
  STAY_LOGGEDIN_BUTTON: "STAY_LOGGEDIN_BUTTON",
  AUTOMATIC_LOGOUT: "AUTOMATIC_LOGOUT",
  BOOK_SESSION: "BOOK_SESSION",
  INTERVIEW_QUESTION_CATEGORY: "INTERVIEW_QUESTION_CATEGORY",
  COPIED_AI_SUMMARY: "COPIED_AI_SUMMARY",
  LIKE_INTERVIEW_SERIES: "LIKED_INTERVIEW_SERIES",
  BOOKMARK_INTERVIEW_SERIES: "BOOKMARK_INTERVIEW_SERIES",
  SAVE_INTERVIEW_SERIES: "SAVE_INTERVIEW_SERIES",
  FEEDBACK_INTERVIEW_SERIES: "FEEDBACK_INTERVIEW_SERIES",

  // Salesforce ENUM
  SALESFORCE_COURSE_HOME: "SALESFORCE_COURSE_HOME",
  SF_ALL_COURSES: "SF_ALL_COURSES",
  SALESFORCE_BANNER_GET_STARTED_TODAY: "SALESFORCE_BANNER_GET_STARTED_TODAY",
  SALESFORCE_BANNER_WATCH_NOW: "SALESFORCE_BANNER_WATCH_NOW",
  SALESFORCE_ABOUT_SUBSCRIBE_NOW: "SALESFORCE_ABOUT_SUBSCRIBE_NOW",
  SALESFORCE_CATEGORIES_ALL: "SALESFORCE_CATEGORIES_ALL",
  SALESFORCE_POPULAR_ALL_COURSES: "SALESFORCE_POPULAR_ALL_COURSES",
  SALESFORCE_OUR_CORE_FEATURES: "SALESFORCE_OUR_CORE_FEATURES",
  SALEFORCE_LATEST_UPDATES_SUBSCRIBE_TO_LSA: "SALEFORCE_LATEST_UPDATES_SUBSCRIBE_TO_LSA",
  SALESFORCE_BLOG_NEW_READ_MORE_BLOGS: "SALESFORCE_BLOG_NEW_READ_MORE_BLOGS",
  SALESFORCE_HERO_SECTION_IMAGE_LINK: "SALESFORCE_HERO_SECTION_IMAGE_LINK",
  SALESFORCE_POPULAR_COURSES_TITLE: "SALESFORCE_POPULAR_COURSES_TITLE",
  SALESFORCE_COURSE_DETAILS_TO_HOME: "SALESFORCE_COURSE_DETAILS_TO_HOME",
  SALESFORCE_COURSE_DETAILS_OVERVIEW_BUTTON: "SALESFORCE_COURSE_DETAILS_OVERVIEW_BUTTON",
  SALESFORCE_COURSE_DETAILS_CURRICULUM_BUTTON: "SALESFORCE_COURSE_DETAILS_CURRICULUM_BUTTON",
  SALESFORCE_COURSE_DETAILS_INSTRUCTOR_BUTTON: "SALESFORCE_COURSE_DETAILS_INSTRUCTOR_BUTTON",
  SALESFORCE_COURSE_DETAILS_REVIEWS_BUTTON: "SALESFORCE_COURSE_DETAILS_REVIEWS_BUTTON",
  SF_COURSES_CLICKED: "SF_COURSES_CLICKED",
  SF_COURSE_CLICKED: "SF_COURSE_CLICKED",
  SF_COURSES_ENROLLED_COURSE: "SF_COURSES_ENROLLED_COURSES",
  SF_ALL_COURSES_TO_SF_COURSE_HOME: "SF_ALL_COURSES_TO_SF_COURSE_HOME",
  SALESFORCE_ALL_EBOOKS: "SALESFORCE_ALL_EBOOKS",
  SALESFORCE_ALL_TRAINING_PROGRAMS: "SALESFORCE_ALL_TRAINING_PROGRAMS",
  SALESFORCE_TUTORIALS_WATCH_MORE_VIDEOS: "SALESFORCE_TUTORIALS_WATCH_MORE_VIDEOS",
  SALESFORCE_EBOOK_DETAILS_TO_HOME: "SALESFORCE_EBOOK_DETAILS_TO_HOME",
  SALESFORCE_EBOOK_DETAILS_OVERVIEW_BUTTON: "SALESFORCE_EBOOK_DETAILS_OVERVIEW_BUTTON",
  SALESFORCE_EBOOK_DETAILS_REVIEWS_BUTTON: "SALESFORCE_EBOOK_DETAILS_REVIEWS_BUTTON",

  // salesforce resources
  SF_ALL_RESOURCES: "SF_ALL_RESOURCES",
  SF_ALL_PRICING: "SF_ALL_PRICING",
  LSA_SALESFORCE_RESOURCE_DETAIL_VIEWED: "LSA_SALESFORCE_RESOURCE_DETAIL_VIEWED",
  LSA_SALESFORCE_RESOURCE_DOWNLOAD_BUTTON: "LSA_SALESFORCE_RESOURCE_DOWNLOAD_BUTTON",
  SALESFORCE_RESOURCE_REVIEWS_BUTTON: "SALESFORCE_RESOURCE_REVIEWS_BUTTON",
  SALESFORCE_PRICING_PLAN_CHOOSE_BUTTON: "SALESFORCE_PRICING_PLAN_CHOOSE_BUTTON",
  SALESFORCE_PRICING_SUCCESS_ALERT_OPENED: "SALESFORCE_PRICING_SUCCESS_ALERT_OPENED",
  SALESFORCE_PRICING_SUCCESS_ALERT_CLOSED: "SALESFORCE_PRICING_SUCCESS_ALERT_CLOSED",
  SF_ALL_ORDERS_PAGE_VIEW: "SF_ALL_ORDERS_PAGE_VIEW",
  SF_ORDER_DETAIL_MODAL_VIEW: "SF_ORDER_DETAIL_MODAL_VIEW",
  SF_EBOOK_DETAIL_VIEW: "SF_EBOOK_DETAIL_VIEW",
  SF_TRAINING_PROGRAMS_DETAIL_VIEW: "SF_TRAINING_PROGRAMS_DETAIL_VIEW",
  SF_TUTORIALS_DETAIL_VIEW: "SF_TUTORIALS_DETAIL_VIEW",

  // React JS ENUM
  REACTJS_COURSE_HOME: "REACTJS_COURSE_HOME",
  REACT_JS_ALL_COURSES: "REACT_JS_ALL_COURSES",
  REACT_JS_BANNER_GET_STARTED_TODAY: "REACT_JS_BANNER_GET_STARTED_TODAY",
  REACT_JS_WE_OFFER_ICON_YOUTUBE: "REACT_JS_WE_OFFER_ICON_YOUTUBE",
  REACT_JS_WE_OFFER_YOUTUBE_TITLE: "REACT_JS_WE_OFFER_YOUTUBE_TITLE",
  REACT_JS_WE_OFFER_YOUTUBE_LEARN_MORE: "REACT_JS_WE_OFFER_YOUTUBE_LEARN_MORE",
  REACT_JS_BANNER_OFFICIAL_LINKEDIN_ACCOUNT: "REACT_JS_BANNER_OFFICIAL_LINKEDIN_ACCOUNT",
  REACT_JS_BANNER_YOUTUBE: "REACT_JS_BANNER_YOUTUBE",
  REACT_JS_BANNER_OFFICIAL_WEBSITE: "REACT_JS_BANNER_OFFICIAL_WEBSITE",
  REACT_JS_LEARN_MORE_TODAY_HOW_IT_WORK: "REACT_JS_LEARN_MORE_TODAY_HOW_IT_WORK",
  REACT_JS_LEARN_MORE_TODAY_YOUTUBE: "REACT_JS_LEARN_MORE_TODAY_YOUTUBE",
  REACT_JS_LET_US_HELP_LEARN_FROM_TODAY: "REACT_JS_LET_US_HELP_LEARN_FROM_TODAY",
  REACT_JS_BLOG_NEWS_READ_MORE_BLOGS: "REACT_JS_BLOG_NEWS_READ_MORE_BLOGS",
  REACT_JS_COURSE_VIEW_ALL_COURSES: "REACT_JS_COURSE_VIEW_ALL_COURSES",
  REACT_JS_COURSE_DETAILS_TO_HOME: "REACT_JS_COURSE_DETAILS_TO_HOME",
  REACTJS_COURSE_DETAILS_OVERVIEW_BUTTON: "REACTJS_COURSE_DETAILS_OVERVIEW_BUTTON",
  REACTJS_COURSE_DETAILS_CURRICULUM_BUTTON: "REACTJS_COURSE_DETAILS_CURRICULUM_BUTTON",
  REACTJS_COURSE_DETAILS_INSTRUCTOR_BUTTON: "REACTJS_COURSE_DETAILS_INSTRUCTOR_BUTTON",
  REACTJS_COURSE_DETAILS_REVIEWS_BUTTON: "REACTJS_COURSE_DETAILS_REVIEWS_BUTTON",
  REACT_ALL_COURSES_TO_REACT_COURSE_HOME: "REACT_ALL_COURSES_TO_REACT_COURSE_HOME",
  REACT_JS_COURSE_CLICKED: "REACT_JS_COURSE_CLICKED",
  REACT_JS_COURSES_ENROLLED_COURSE: "REACT_JS_COURSES_ENROLLED_COURSES",

  // Javascript Enum
  JAVASCRIPT_COURSE_HOME: "JAVASCRIPT_COURSE_HOME",
  JAVASCRIPT_ALL_COURSES: "JAVASCRIPT_ALL_COURSES",
  JAVASCRIPT_BANNER_GET_STARTED_TODAY: "JAVASCRIPT_BANNER_GET_STARTED_TODAY",
  JAVASCRIPT_ABOUT_SUBSCRIBE_NOW: "JAVASCRIPT_ABOUT_SUBSCRIBE_NOW",
  JAVASCRIPT_COURSE_VIEW_ALL_COURSES: "JAVASCRIPT_COURSE_VIEW_ALL_COURSES",
  JAVASCRIPT_TESTIMONIALS_LEFT_CLICK: "JAVASCRIPT_TESTIMONIALS_LEFT_CLICK",
  JAVASCRIPT_TESTIMONIALS_RIGHT_CLICK: "JAVASCRIPT_TESTIMONIALS_RIGHT_CLICK",
  JAVASCRIPT_UPCOMMING_EVENT_GET_TICKET: "JAVASCRIPT_UPCOMMING_EVENT_GET_TICKET",
  JAASCRIPT_NEWS_LETTER_SUBSCRIBE_NOW: "JAASCRIPT_NEWS_LETTER_SUBSCRIBE_NOW",
  JAVASCRIPT_COURSE_DETAILS_OVERVIEW_BUTTON: "ALL_COURSE_DETAILS_OVERVIEW_BUTTON",
  JAVASCRIPT_COURSE_DETAILS_CURRICULUM_BUTTON: "ALL_COURSE_DETAILS_CURRICULUM_BUTTON",
  JAVASCRIPT_COURSE_DETAILS_INSTRUCTOR_BUTTON: "ALL_COURSE_DETAILS_INSTRUCTOR_BUTTON",
  JAVASCRIPT_COURSE_DETAILS_REVIEWS_BUTTON: "ALL_COURSE_DETAILS_REVIEWS_BUTTON",
  JAVASCRIPT_COURSE_DETAILS_TO_HOME: "JAVASCRIPT_COURSE_DETAILS_TO_HOME",
  JAVASCRIPT_ALL_COURSES_TO_JAVASCRIPT_HOME: "JAVASCRIPT_ALL_COURSES_TO_JAVASCRIPT_HOME",
  JAVASCRIPT_COURSES_CLICKED: "JAVASCRIPT_COURSES_CLICKED",
  JAVASCRIPT_COURSE_CLICKED: "JAVASCRIPT_COURSE_CLICKED",
  JAVASCRIPT_COURSES_ENROLLED_COURSE: "JAVASCRIPT_COURSES_ENROLLED_COURSES",

  //Common footer
  ALL_COURSE_DETAILS_TO_HOME: "ALL_COURSE_DETAILS_TO_HOME",
  COMMON_FOOTER_APPLY_NOW: "COMMON_FOOTER_APPLY_NOW",
  COMMON_FOOTER_SUBSCRIBE_NOW: "COMMON_FOOTER_SUBSCRIBE_NOW",
  COMMON_FOOTER_LOGO: "COMMON_FOOTER_LOGO",
  LINK: "LINK",
  COMMON_FOOTER_OFFICIAL_WEBSITE: "OFFICIAL_WEBSITE",
  COMMON_FOOTER_OFFICIAL_LINKEDIN: "OFFICIAL_LINKEDIN",
  COMMON_FOOTER_OFFICIAL_YOUTUBE: "COMMON_FOOTER_OFFICIAL_YOUTUBE",
  COMMON_FOOTER_ABOUT_US: "COMMON_FOOTER_ABOUT_US",
  // COMMON_FOOTER_OUR_GALLERY: "COMMON_FOOTER_OUR_GALLERY",
  COMMON_FOOTER_SALESFORCE_TUTORIALS: "COMMON_FOOTER_SALESFORCE_TUTORIALS",
  COMMON_FOOTER_SALESFORCE_QUICK_INSIGHTS: "COMMON_FOOTER_SALESFORCE_QUICK_INSIGHTS",
  COMMON_FOOTER_BLOG_NEWS: "COMMON_FOOTER_BLOG_&_NEWS",
  COMMON_FOOTER_FAQ: "COMMON_FOOTER_FAQ",
  COMMON_FOOTER_TESTIMONIAL: "COMMON_FOOTER_TESTIMONIAL",
  COMMON_FOTTER_PRIVACY_POLICY: "COMMON_FOTTER_PRIVACY_POLICY",
  COMMON_FOOTER_CONTACT_US: "COMMON_FOOTER_CONTACT_US",
  COMMON_FOOTER_POPULAR_COURSES: "COMMON_FOOTER_POPULAR_COURSES",
  COMMON_FOOTER_OFFICIAL_PHONE_NUMBER: "COMMON_FOOTER_OFFICIAL_PHONE_NUMBER",
  COMMON_FOOTER_OFFICIAL_EMAIL_ADDRESS: "COMMON_FOOTER_OFFICIAL_EMAIL_ADDRESS",
  COPPY_RIGHT_OFFICAL_WEBSITE: "COPPY_RIGHT_OFFICAL_WEBSITE",
  COMMON_FOOTER_SUGGESTION_FORM_OPENED: "COMMON_FOOTER_SUGGESTION_FORM_OPENED",
  COMMON_FOOTER_SUGGESTION_FORM_CLOSED: "COMMON_FOOTER_SUGGESTION_FORM_CLOSED",
  COMMON_FOOTER_SUGGESTION_SUBMITTED: "COMMON_FOOTER_SUGGESTION_SUBMITTED",
  CUSTOMER_INFO_FORM_OPENED: "CUSTOMER_INFO_FORM_OPENED",
  CUSTOMER_INFO_FORM_CLOSED: "CUSTOMER_INFO_FORM_CLOSED",
  CUSTOMER_INFO_SUBMITTED: "CUSTOMER_INFO_SUBMITTED",
  TESTIMONIAL_FORM_OPENED: "TESTIMONIAL_FORM_OPENED",
  TESTIMONIAL_FORM_CLOSED: "TESTIMONIAL_FORM_CLOSED",
  TESTIMONIAL_FORM_SUBMITTED: "TESTIMONIAL_FORM_SUBMITTED",

  // FAQs Enum
  ALL_FAQS_TO_HOME: "ALL_FAQS_TO_HOME",
  ALL_FAQS_PAGE_ACCORDIAN_BUTTON: "ALL_FAQS_PAGE_ACCORDIAN_BUTTON",

  // Forms
  LSA_LOGIN_FORM_VIEWED: "LSA_LOGIN_FORM_VIEWED",
  LSA_REGISTER_FORM_VIEWED: "LSA_REGISTER_FORM_VIEWED",

  // About us Enum
  ABOUT_US_PAGE_CHOOSE_GUIDENCE_EXPLORE_COURSES: "ABOUT_US_PAGE_CHOOSE_GUIDENCE_EXPLORE_COURSES",
  ABOUT_US_PAGE_LEARN_FREE_MORE_UPCOMING_VIDEOS: "ABOUT_US_PAGE_LEARN_FREE_MORE_UPCOMING_VIDEOS",
  ABOUT_US_PAGE_LEARN_FOR_FREE_VIDEO_PLAY: "ABOUT_US_PAGE_LEARN_FOR_FREE_VIDEO_PLAY",

  // Contact us Enum
  CONTACT_US_TO_HOME: "CONTACT_US_TO_HOME",
  CONTACT_US_OFFICAL_WEBSITE: "CONTACT_US_OFFICAL_WEBSITE",
  CONTACT_US_OFFICIAL_EMAIL_ADDRESS: "CONTACT_US_OFFICIAL_EMAIL_ADDRESS",
  CONTACT_US_OFFICIAL_PHONE_NUMBER: "CONTACT_US_OFFICIAL_PHONE_NUMBER",
  CONTACT_US_GOOGLE_MAP: "CONTACT_US_GOOGLE_MAP", //PENDING
  CONTACT_US_FORM_SUBMIT_BUTTON: "CONTACT_US_FORM_SUBMIT_BUTTON",
  SUGGEST_TOPIC_FORM_SUBMIT_BUTTON: "SUGGEST_TOPIC_FORM_SUBMIT_BUTTON",

  // Privacy policy Enum
  PRIVACY_POLICY_TO_HOME: "PRIVACY_POLICY_TO_HOME",

  // Testimonial Enum
  ALL_TESTIMONIALS_TO_HOME: "ALL_TESTIMONIALS_TO_HOME",
  TESTIMONIAL_NAVIGATE_TO_EBOOK: "TESTIMONIAL_NAVIGATE_TO_EBOOK",
  TESTIMONIAL_NAVIGATE_TO_GET_CONSULTATION: "TESTIMONIAL_NAVIGATE_TO_GET_CONSULTATION",

  // all courses pages
  LSA_ALL_COURSES_ENROLLED_COURSE: 'LSA_ALL_COURSES_ENROLLED_COURSE',
  LSA_ALL_COURSES_CLICKED: 'LSA_ALL_COURSES_CLICKED',

  // support us form Enum
  LSA_SUPPORT_FORM_VIEW: "LSA_SUPPORT_FORM_VIEW",
  LSA_SUPPORT_FORM_CLOSE: "LSA_SUPPORT_FORM_CLOSE",
  LSA_SUPPORT_FORM_UPI_COPIED: "LSA_SUPPORT_FORM_UPI_COPIED",
  LSA_SUPPORT_FORM_THANKYOU_BTN_CLICK: "LSA_SUPPORT_FORM_THANKYOU_BTN_CLICK",

  // Course Detail page
  LSA_SALESFORCE_COURSE_REACTION_ADDED: "LSA_SALESFORCE_COURSE_REACTION_ADDED",
  LSA_SALESFORCE_COURSE_COMMENT_ADDED: "LSA_SALESFORCE_COURSE_COMMENT_ADDED",
  LSA_SALESFORCE_COURSE_COMMENT_LIKED: "LSA_SALESFORCE_COURSE_COMMENT_LIKED",
  LSA_SALESFORCE_COURSE_COMMENT_UPDATED: "LSA_SALESFORCE_COURSE_COMMENT_UPDATED",
  LSA_SALESFORCE_COURSE_COMMENT_DELETED: "LSA_SALESFORCE_COURSE_COMMENT_DELETED",
  LSA_SALESFORCE_COURSE_COMMENT_REPLY_ADDED: "LSA_SALESFORCE_COURSE_COMMENT_REPLY_ADDED",
  LSA_SALESFORCE_BLOG_COMMENT_ADDED: "LSA_SALESFORCE_BLOG_COMMENT_ADDED",
  LSA_SALESFORCE_BLOG_COMMENT_LIKED: "LSA_SALESFORCE_BLOG_COMMENT_LIKED",
  LSA_SALESFORCE_BLOG_COMMENT_UPDATED: "LSA_SALESFORCE_BLOG_COMMENT_UPDATED",
  LSA_SALESFORCE_BLOG_COMMENT_DELETED: "LSA_SALESFORCE_BLOG_COMMENT_DELETED",
  LSA_SALESFORCE_BLOG_COMMENT_REPLY_ADDED: "LSA_SALESFORCE_BLOG_COMMENT_REPLY_ADDED",
  LSA_SALESFORCE_COMMENT_CANCEL_BUTTON_CLICKED: "LSA_SALESFORCE_COMMENT_CANCEL_BUTTON_CLICKED",
  LSA_SALESFORCE_VIEW_ALL_COMMENT_BUTTON_CLICKED: "LSA_SALESFORCE_VIEW_ALL_COMMENT_BUTTON_CLICKED",
  LSA_SALESFORCE_HIDE_ALL_COMMENT_BUTTON_CLICKED: "LSA_SALESFORCE_HIDE_ALL_COMMENT_BUTTON_CLICKED",
  LSA_SALESFORCE_BLOG_LIKE_ADDED: "LSA_SALESFORCE_BLOG_LIKE_ADDED",
  LSA_SALESFORCE_COURSE_LIKE_ADDED: "LSA_SALESFORCE_COURSE_LIKE_ADDED",
  LSA_SALESFORCE_VISITED_COMMENT_REPLY_FORM: "LSA_SALESFORCE_VISITED_COMMENT_REPLY_FORM",
  LSA_SALESFORCE_COMMENT_ACTIONS_MENU_CLICKED: "LSA_SALESFORCE_COMMENT_ACTIONS_MENU_CLICKED",
  LSA_SALESFORCE_COMMENT_REPLY_MODAL_OPENED: "LSA_SALESFORCE_COMMENT_REPLY_MODAL_OPENED",
  LSA_SALESFORCE_COMMENT_DELETE_MODAL_OPENED: "LSA_SALESFORCE_COMMENT_DELETE_MODAL_OPENED",
  LSA_SALESFORCE_COMMENT_EDIT_MODAL_OPENED: "LSA_SALESFORCE_COMMENT_EDIT_MODAL_OPENED",
  LSA_SALESFORCE_QUICK_INSIGHT_LIKED: "LSA_SALESFORCE_QUICK_INSIGHT_LIKED",
  LSA_SALESFORCE_QUICK_INSIGHT_BOOKMARKED: "LSA_SALESFORCE_QUICK_INSIGHT_BOOKMARKED",
  LSA_SALESFORCE_QUICK_INSIGHT_UPVOTED: "LSA_SALESFORCE_QUICK_INSIGHT_UPVOTED",
  LSA_SALESFORCE_QUICK_INSIGHT_DOWNVOTED: "LSA_SALESFORCE_QUICK_INSIGHT_DOWNVOTED",
  LSA_SALESFORCE_QUICK_INSIGHT_SHARED: "LSA_SALESFORCE_QUICK_INSIGHT_SHARED",

  //share button Enum
  LSA_SHARE_ON_LINKEDIN: "LSA_SHARE_ON_LINKEDIN",
  LSA_SHARE_ON_INSTAGRAM: "LSA_SHARE_ON_INSTAGRAM",
  LSA_SHARE_ON_WHATSAPP: "LSA_SHARE_ON_WHATSAPP",
  LSA_SHARE_ON_TWITTER: "LSA_SHARE_ON_TWITTER",
  LSA_SHARE_ON_FACEBOOK: "LSA_SHARE_ON_FACEBOOK",
  LSA_COPY_COURSE_LINK: "LSA_COPY_COURSE_LINK",

  // Course Info Enum
  LSA_VIDEO_PLAYED_BUTTON_CLICKED: "LSA_VIDEO_PLAYED_BUTTON_CLICKED",

  // Instructor pge Enum
  LSA_INSTRUCTOR_LINKEDIN_PROFILE_CLICKED: "LSA_INSTRUCTOR_LINKEDIN_PROFILE_CLICKED",
  LSA_INSTRUCTOR_WEBSITE_LINK_CLICKED: "LSA_INSTRUCTOR_WEBSITE_LINK_CLICKED",
  LSA_INSTRUCTOR_YOUTUBE_CHANNEL_CLICKED: "LSA_INSTRUCTOR_YOUTUBE_CHANNEL_CLICKED",
  LSA_INSTRUCTOR_EMAIL_CLICKED: "LSA_INSTRUCTOR_EMAIL_CLICKED",

  // YouTube Short Info Enum
  LSA_SALESFORCE_TUTORIALS_VIDEO_PLAYED_BUTTON_CLICKED: "LSA_SALESFORCE_TUTORIALS_VIDEO_PLAYED_BUTTON_CLICKED",

};
export { pageView, triggerFunction, GoogleAnalyticsEnum }
